import wretch from "wretch";
import AbortAddon from "wretch/addons/abort";
import QueryStringAddon from "wretch/addons/queryString";

import { env } from "@/config/env";

const configuredOrigin = new URL(env.VITE_BASE_API_URL).origin;

const BASE_URL =
  window.location.origin === configuredOrigin
    ? env.VITE_BASE_API_URL
    : window.location.origin;

const authenticatedApi = wretch(`${BASE_URL}/api/v1`)
  .addon(QueryStringAddon)
  .addon(AbortAddon())
  .options({
    credentials: "include",
  })
  .resolve((resolver) =>
    resolver
      .fetchError(() => {
        // TODO: add toast on error
        throw new Error("Failed to connect to server");
      })
      .unauthorized(() => {
        handleLogout();
      }),
  )
  .catcherFallback((error) => {
    throw error.json;
  });

export default authenticatedApi;

function handleLogout() {
  if (window.location.pathname.startsWith("/login")) return;
  const here =
    window.location.pathname + window.location.search + window.location.hash;
  const existingRedirect = new URLSearchParams(window.location.search).get(
    "redirect",
  );
  const redirectParam = here.startsWith("/login")
    ? existingRedirect
      ? `?redirect=${encodeURIComponent(existingRedirect)}`
      : ""
    : `?redirect=${encodeURIComponent(here)}`;

  window.location.href = `/login${redirectParam}`;
}

export const unauthenticatedApi = wretch(`${BASE_URL}/api/v1`)
  .addon(QueryStringAddon)
  .options({
    credentials: "include",
  })
  .resolve((resolver) =>
    resolver.fetchError(() => {
      // TODO: add toast on error
      throw new Error("Failed to connect to server");
    }),
  )
  .catcherFallback((error) => {
    throw error.json;
  });

export class HttpError extends Error {
  constructor(
    message: string,
    public status: number,
  ) {
    super(message);
  }
}
